import React from "react";
import {
  QueryAvailableReplaySeasons,
  QueryCurrentReplayState,
  SubscribeReplayStateUpdate,
} from "../../../utils/graphql/hooks/replayHooks";

export default function ReplayDataManager() {
  QueryAvailableReplaySeasons();
  QueryCurrentReplayState();
  SubscribeReplayStateUpdate();
  return <></>;
}
